import React from 'react'
import {LinkButton} from '@components/common/base/buttons'
import {TablerIcons} from '@components/common/icon-tabler/icon-tabler'
import {
  TwCell,
  TwCellFunctionsCompensator, TwInnerCell,
  TwRowContainer,
  TwRowShell
} from '@components/common/sandbox/list-view/tw-components'

interface LinkButtonRowProps {
  children?: React.ReactNode,
  onClick: () => void,
  icon?: TablerIcons,
  nestingMargin: number
}

export const LinkButtonRow = (props: LinkButtonRowProps) => {
  const {
    children,
    onClick,
    icon,
    nestingMargin
  } = props


  return (
    <TwRowContainer>
      <TwRowShell style={{
        marginLeft: `${nestingMargin}px`
      }}>
        <TwCell>
          <TwInnerCell>
            <TwCellFunctionsCompensator />
            <LinkButton
              icon={icon}
              noPaddings
              size="small"
              onClick={onClick}
              className="ml-4"
            >
              {children}
            </LinkButton>
          </TwInnerCell>
        </TwCell>
      </TwRowShell>
    </TwRowContainer>
  )
}